module.exports = __webpack_public_path__ + "assets/img/back.b92f3b1c.png";